<button *ngIf="action === 'modal'; else redirect" (click)="openModal()">
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</button>

<ng-template #redirect>
  <a [routerLink]="{ cxRoute: 'addCompany' } | cxUrl">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </a>
</ng-template>

<ng-template #content>
  <span class="icon-wrapper">
    <cx-icon type="PLUS"></cx-icon>
  </span>

  <span class="btn-text">Добавить компанию</span>
</ng-template>
